export const TABS = Object.freeze({
	'ENROLLMENT': { value: 1, label: 'Enrollment', export: 'enrollment' },
	'CLAIMS': { value: 2, label: 'Claims', export: 'claims' },
	'CONDITIONS': { value: 3, label: 'Conditions', export: 'conditions' },
	'RISK': { value: 4, label: 'Risk Score Data', export: 'riskscoredata' },
	'RARSD_RISK': { value: 5, label: 'RARSD Risk Score Trend', export: 'rarsdriskscoretrend' },
	'GAPS': { value: 6, label: 'Gaps', export: 'gap' },
	'PCP': { value: 7, label: 'PCP', export: 'pcp' }
});